import axios from 'axios';
import URLS from '../util/urls.js';
import funcoes from '../util/funcoes.js';

const state = {
  parcerias: [],
  parceriaPesquisa: {
    dataInicial: funcoes.primeiroDiaMes(),
    dataFinal: funcoes.ultimoDiaMes()
  },
  parceria: {
    imobiliaria: { id: 0 },
    usuario: { id: 0 }
  },

  labelQuantidade: '',
}

const mutations = {
  limparParceriaPesquisa(state) {
    state.parceriaPesquisa = {
      dataInicial: funcoes.primeiroDiaMes(),
      dataFinal: funcoes.ultimoDiaMes()
    }
  },
  limparParceriasListadas(state) {
    state.parcerias = []
  },
  atualizarParceriasListadas(state, payload) {
    state.parcerias = payload;
  },
  atualizarParceria(state, payload) {
    state.parceria = payload;
  }
}

const actions = {
  limparParceriaPesquisa(context) {
    context.commit('limparParceriaPesquisa');
  },
  limparParceriasListadas(context) {
    context.commit('limparParceriasListadas');
  },

  listarParcerias(context, payload) {
    return axios.post(URLS.PARCERIAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarParceriasListadas', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarParcerias', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      context.commit('limparParceriasListadas');
      throw error;
    });
  },
  recuperarParceria(context, payload) {
    return axios.post(URLS.PARCERIAS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarParceria', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarParceria', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  aceitarParceria(context, payload) {
    return axios.post(URLS.PARCERIAS_ACEITAR_PARCERIA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarParceria', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('aceitarParceria', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  rejeitarParceria(context, payload) {
    return axios.post(URLS.PARCERIAS_REJEITAR_PARCERIA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarParceria', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('rejeitarParceria', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  }
}

export default {
  state,
  mutations,
  actions
}